import {
	ADD_IMAGES,
	ADD_TEMP_IMAGES,
	UPDATE_TEMP_IMAGE,
	REMOVE_TEMP_IMAGES,
	RESET_IMAGES,
	UPDATE_IMAGE
} from "../../constants"

export const addImages = ( images ) => {
	return {
		type: ADD_IMAGES,
		payload: {
			images: images
		}
	};
};

export const resetImages = () => {
	return {
		type: RESET_IMAGES
	};
};

export const updateImage = ( image ) => {
	return {
		type: UPDATE_IMAGE,
		payload: {
			image: image
		}
	};
};

export const addTempImage = ( image ) => {
	return {
		type: ADD_TEMP_IMAGES,
		payload: {
			id: image.id
		}
	};
};

export const removeTempImage = ( image ) => {
	return {
		type: REMOVE_TEMP_IMAGES,
		payload: {
			id: image.id
		}
	};
};

export const updateTempImage = ( image ) => {
	return {
		type: UPDATE_TEMP_IMAGE,
		payload: {
			id: image.id,
			progress: image.progress
		}
	};
};


// WEBPACK FOOTER //
// ./src/api/images/actions.js